import validate from '../../../services/reduxValidate.js'

export default function(data) {
  return validate(data, {
    email: { email: true, presence: true }
  })
}